import { Controller } from 'stimulus';

import universalTracking from '../tracking/universalTracking';
import delegatedEventListener from '../helpers/delegatedEventListener';

class Tracking extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    Tracking.trackTiming();
    Tracking.trackLinks();
  }

  static trackLinks() {
    delegatedEventListener('click', 'a', document, ({ target }) => {
      if (target.matches('a[href^="tel:"]')) {
        universalTracking.event('Phone', 'click', target.href);
        return;
      }

      if (target.matches('a[href^="mailto:"]')) {
        universalTracking.event('Mail', 'click', target.href);
        return;
      }

      if (
        target.href.indexOf(window.location.host) <= 0
        && target.href.match(/^http/i)
      ) {
        universalTracking.event('Outbound', 'click', target.href);
      }
    });
  }

  static trackTiming() {
    if (!('performance' in window) || !('PerformanceObserver' in window)) {
      return;
    }

    const observer = new PerformanceObserver(this.measureTiming);
    observer.observe({ entryTypes: ['navigation'] });
  }

  static measureTiming(list) {
    const entries = list.getEntries();

    entries.forEach((entry) => {
      universalTracking.timing('ttfb', entry.responseStart - entry.requestStart);
      universalTracking.timing('domInteractive', entry.domInteractive - entry.requestStart);
    });
  }
}

Tracking.targets = [
  //
];

export default Tracking;
